import React from 'react'
import { catchSyncStacktrace } from 'auto-trace'
import cancelable from 'react-disposable-decorator'
// project imports
import styles from './remember-me.styles.css'
import { NavContent } from '../../login-ui.js'
import { rememberDevice } from './remember-me.resource.js'
import { hideRememberMePrompt } from '../../utilities/togglePrompt.js'
// sofe imports
import { infoToast } from 'toast-service!sofe'

@cancelable
export default class RememberMe extends React.PureComponent {

  componentDidMount() {
    this.rememberMe.addEventListener('animationend', this.onAnimationEnd, false)
    // Prompt shows for 5 minutes if the user doesn't act on it
    this.timeout = setTimeout(() => {
      this.remove()
    }, 1000 /* 1 second */ * 60 /* 1 minute */ * 5 /* 5 minutes */)

    // if we show the prompt hide the prompt on any refresh
    window.addEventListener('beforeunload', this.immediatelyRemove)
  }

  state = {
    beenDismissed: false,
    checked: false
  }

  render () {
    return (
      <NavContent hasTopnavSecondary={false} contactMenuPossible={false} style={{marginLeft: 0, width: '100%', padding: 0}}>
        <div
          ref={(el) => {this.rememberMe = el}}
          className={`${styles.rememberMe} ${this.state.beenDismissed ? styles.out : styles.in} cps-padding-top-8`}
        >
          <div className={`cps-card__height-3 ${styles.card}`}>
            <div className={`cps-padding-24`}>
              <div className={`cps-subheader-sm`}>
                Thank you for verifying your identity!
              </div>
              <div className={`cps-padding-top-8`}>
                <form>
                  <label className="cps-checkbox-large">
                    <div style={{display: 'flex'}}>
                      <input
                        ref={(el) => this.checkbox = el}
                        tabIndex={1}
                        type="checkbox"
                        checked={this.state.checked}
                        onChange={this.checkboxHandler}
                        disabled={this.state.checked}
                      />
                      <span>
                        Remember this device for 30 days?
                      </span>
                    </div>
                  </label>
                </form>
              </div>
            </div>
            <div className={`${styles.doNotRememberWrapper} cps-padding-top-16 cps-padding-right-24`}>
              <div>
                <i
                  tabIndex={2}
                  className={`cps-icon cps-icon-close ${styles.doNotRememberButton}`}
                  onKeyPress={this.removeKeyPress}
                  onClick={this.remove}
                />
              </div>
            </div>
          </div>
        </div>
      </NavContent>
    )
  }

  componentWillUnmount() {
    window.clearTimeout(this.timeout)
    window.removeEventListener('beforeunload', this.immediatelyRemove)
    this.rememberMe.removeEventListener('animationend', this.onAnimationEnd, false)
  }

  checkboxHandler = () => {
    this.setState((prevState) => {
      return {checked: !prevState.checked}
    }, this.rememberDevice)
  }

  rememberDevice = () => {
    if (this.state.checked) {

      this.props.cancelWhenUnmounted(
        rememberDevice().subscribe(
          () => {
            infoToast(`This device will be remembered for 30 days.`)
            this.remove()
          },
          (err) => {
            hideRememberMePrompt()
            catchSyncStacktrace(err)
          }
        )
      )
    }
  }

  onAnimationEnd = () => {
    if (!this.state.beenDismissed) {
      this.checkbox.focus()
    } else {
      hideRememberMePrompt()
    }
  }

  removeKeyPress = (e) => {
    if (e.key === 'Enter') {
      this.remove()
    }
  }

  remove = () => {
    this.setState({beenDismissed: true})
  }

  immediatelyRemove = () => {
    hideRememberMePrompt()
  }
}
